import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../shared/services/api.service';
import { AddressInterface } from '../models/address.interface';
import { ExtranetService } from '../../shared/services/extranet.service';
import { MfaInterface } from '../../shared/models/mfa.interface';

@Injectable()
export class AddressService {

  constructor(
      private apiService: ApiService,
      private extranetService: ExtranetService
  ) {}

  /**
   * Get shipping address
   */
  get(): Observable<Array<AddressInterface>> {
    return this.apiService.get('shipping/address');
  }

  /**
   * Update shipping address
   * @param data
   * @param mfa
   */
  update(data: AddressInterface, mfa: MfaInterface|null = null): Observable<any> {
    let body = data;
    if (mfa) {
     body = Object.assign({ action: mfa.action, code: mfa.code, destination: mfa.destination }, data);
    }
    let url = 'ec/shipping/address';
    if (this.extranetService.getSupportUser()) {
      url = 'extranet/shipping/address';
    }
    return this.apiService.put(url, body);
  }

  /**
   * Set principal shipping address
   * @param id
   * @param isPrincipal
   * @param password
   */
  setPrincipalAddress(id: number, isPrincipal: boolean, password?: string): Observable<any> {
    const body = {id, isPrincipal, password};
    let url = 'ec/shipping/address/principal';
    if (this.extranetService.getSupportUser()) {
      url = 'extranet/shipping/address/principal';
    }
    return this.apiService.put(url, body);
  }

  /**
   * Delete shipping address
   *
   * @param id
   * @param password
   */
  deleteShippingAddress(id: number, password?: string): Observable<any> {
    const body = {id, password};
    let url = 'ec/shipping/address/delete';
    if (this.extranetService.getSupportUser()) {
      url = 'extranet/shipping/address/delete';
    }
    return this.apiService.put(url, body);
  }

  /**
   * Create shipping address
   * @param address
   * @param mfa
   */
  createShippingAddress(address: AddressInterface, mfa: MfaInterface|null = null): Observable<any> {
    let body = address;
    if (mfa) {
      body = Object.assign({ action: mfa.action, code: mfa.code, destination: mfa.destination }, address);
    }
    let url = 'ec/shipping/address';
    if (this.extranetService.getSupportUser()) {
      url = 'extranet/create/shipping/address';
    }
    return this.apiService.post(url, body);
  }
}
